import { useRef, useState } from 'react';
import { imgs } from '../assets/imgs';
import { tracking } from '../utils/tracking';
import { Banner, InfoSection, PressForm, VideoSection } from '../components';
import { useResizeImg } from '../hooks/useResizeImg';

const vidUrl = "https://www.youtube.com/embed/KZ_SWkS-Ojg";
const vidHeader = "Watch the trailer for the Venture Summit";

export const Press = () => {
   document.title = "New York Venture Summit | Press";
   const [isLoading, setIsLoading] = useState(true);
   const imageSource = useResizeImg(imgs.press.pressBannerDesktop, imgs.press.pressBannerMobile)
   const scrollRef = useRef(null);
   return (
      <div className='press'>
         <Banner imageSource={imageSource} isLoading={isLoading} setIsLoading={setIsLoading} >
            <section>
               <h1>Media</h1>
               <h1>Share with the Whole World the Best in Tech</h1>
            </section>
            <section>
               <button className="btn b2" onClick={() => { tracking(342); scrollRef.current.scrollIntoView({ behavior: 'smooth' }) }}>APPLY NOW</button>
            </section>
         </Banner>
         <InfoSection  img={imgs.press.pressInfo}>
            <h1>Press and Media</h1>
            <span></span>
            <p>As the global leaders of technology assemble, so too do Journalists from the world’s most influential publications.</p>
            <p>Gain access to a massive global, influential network of companies and top innovators and assist us in showcasing these emerging companies to the world.</p>
            <p>Media accreditation will be determined based upon your credentials.</p>
            <p>Apply below and join us for the New York Tech Venture Summit.</p>
         </InfoSection>
         <VideoSection url={vidUrl} header={vidHeader} />
         <div ref={scrollRef} style={{ scrollMargin: '70px' }} />
         <PressForm />
      </div>
   )
}
